import { Controller } from "@hotwired/stimulus"
import EmblaCarousel from "embla-carousel"

/**
 * Tag/Listen-Leiste: horizontales Drag-Scroll via Embla + Live-Suche.
 *
 * Embla kümmert sich um Touch-Swipe, Maus-Drag und Momentum-Scroll.
 * Suche filtert Tags live per Stimulus.
 */
export default class extends Controller {
  static targets = ["searchWrap", "input", "list", "tag", "viewport"]

  connect() {
    if (this.hasViewportTarget) {
      this.embla = EmblaCarousel(this.viewportTarget, {
        dragFree: true,
        containScroll: "trimSnaps",
        align: "start"
      })
    }
  }

  disconnect() {
    this.embla?.destroy()
  }

  toggle() {
    if (this.hasSearchWrapTarget) {
      const hidden = this.searchWrapTarget.classList.toggle("hidden")
      if (!hidden && this.hasInputTarget) {
        this.inputTarget.value = ""
        this.inputTarget.focus()
        this.showAll()
      }
    }
  }

  filter() {
    const q = (this.inputTarget.value || "").toLowerCase().trim()
    this.tagTargets.forEach((tag) => {
      const name = tag.dataset.tagName || ""
      tag.style.display = q && !name.includes(q) ? "none" : ""
    })
    // Embla nach Filter-Änderung neu berechnen
    this.embla?.reInit()
  }

  showAll() {
    this.tagTargets.forEach((tag) => { tag.style.display = "" })
    this.embla?.reInit()
  }
}
